import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { useLang } from "@/i18n/LanguageContext";

export const FAQSection = () => {
  const { t } = useLang();
  const f = t.faq;
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="relative scroll-mt-24 py-24 lg:py-32">
      <div className="mx-auto max-w-3xl px-5">
        <SectionHeading eyebrow={f.eyebrow} title={f.title} intro={f.intro} align="center" testId="faq-heading" />

        <div className="mt-12 space-y-3" data-testid="faq-list">
          {f.items.map((it, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="glass-card rounded-2xl overflow-hidden" data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 p-5 text-left"
                  aria-expanded={isOpen}
                  data-testid={`faq-question-${i}`}
                >
                  <span className="font-display font-semibold text-white text-base">{it.q}</span>
                  <span className="grid place-items-center h-7 w-7 shrink-0 rounded-full border border-[var(--line-strong)] text-[var(--blue-bright)]">
                    {isOpen ? <Minus size={15} /> : <Plus size={15} />}
                  </span>
                </button>
                <div className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm text-white/90 leading-relaxed" data-testid={`faq-answer-${i}`}>{it.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
